import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef
} from '@angular/core';

import { SCHEMAS } from './card-list.config';
import { CardList } from './card-list.interface';
import { DataTableService } from '../data-table/data-table.service';
import { SnackbarService } from '../snackbar/snackbar.service';

@Component({
  standalone: false,
  selector: 'app-card-list',
  templateUrl: './card-list.component.html',
  styleUrls: ['./card-list.component.scss']
})
export class CardListComponent implements OnInit, OnChanges {
  @Input() id = '';
  @Input() type: string;
  @Input() data: any[];
  @Input() expandableData: any[];
  @Input() disableExpandable: boolean;
  @Output() detail = new EventEmitter<any>();
  @Output() action = new EventEmitter<any>();
  @Output() iconFooter = new EventEmitter<any>();
  @Output() isSubmit = new EventEmitter<any>();
  @Output() iconHeaderPanel = new EventEmitter<any>();
  checkList = [];
  itemValue = [];
  checkedDialogCheck = false;
  hability;
  schema: CardList;
  showActionIcons = false;
  selectedElements: any[] = [];

  dataCheckConfirm = [];

  constructor(public dataTableService: DataTableService
    , private snackbarService: SnackbarService
    , private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.schema = SCHEMAS[this.type];
    this.id = this.id !== '' ? this.id + '-' : '';
  }

  ngOnChanges() {
    this.showActionIcons = false;
    this.selectedElements = [];
    this.dataCheckConfirm = [];
    if (this.data && this.data.length > 0) {
      this.checkList = this.data.map(() => {
        return false;
      });
    }
  }

  onChangeColumnTitle(name: string, title: string, hability: boolean) {
    this.schema.items.find(item => item.name === name).title = title;
    this.hability = hability;
  }

  viewRecord(data: any) {
    if (this.schema && this.schema.expandable) {
      this.detail.emit(data);
      this.selectedElements = [];
      this.showActionIcons = false;
    }
  }

  hiddenIcon(ico, item) {
    return ico.hasVisibleCondition(item);
  }

  selectElement(checked: boolean, data: any, index: number) {
    if (checked) {
      this.selectedElements[index] = data;
    } else {
      delete this.selectedElements[index];
    }
    this.showActionIcons =
      this.selectedElements.filter(element => !!element).length > 0;
  }

  isDisabledIconHeader(typeIcon: any): boolean {
    if (typeIcon.hasVisibleCondition) {
      return !typeIcon.hasVisibleCondition(this.selectedElements.filter(item => item));
    }
    return false;
  }

  iconHeader(name: string) {
    this.action.emit({
      action: name,
      data: this.selectedElements.filter(item => item)
    });
  }

  getEntityCode(orderId: string): string {
    const findOrder = this.data.find(order => order.orderId === orderId);
    return findOrder ? findOrder.entityCode : '';
  }

  onClickIconFooter(name: string, data, i) {
    this.iconFooter.emit({ ico: name, data: data, index: i });
  }

  submit(event) {
    if (event) {
      (this.dataCheckConfirm && this.dataCheckConfirm.length > 0) ?
        this.isSubmit.emit({ data: this.dataCheckConfirm }) : this.snackbarService.show('Seleccione al menos un registro', 'warning');
    }
  }

  changeCheck(value, index) {
    if (value) {
      this.dataCheckConfirm.push(this.data[index]);
    } else {
      const indexSplice = this.dataCheckConfirm.findIndex(element => element === this.data[index]);
      if (indexSplice >= 0) {
        this.dataCheckConfirm.splice(indexSplice, 1);
      }
    }
  }

  totalSelection(valueCheck) {
    if (valueCheck) {
      this.isAllSelected();
      this.asignData(true);
    } else {
      this.asignData(false);
      this.dataCheckConfirm = [];
    }
  }

  isAllSelected() {
    this.dataCheckConfirm = this.schema.hasDisabledCheckBoxItem ?
      this.data.filter(row => !this.schema.hasDisabledCheckBoxItem(row)) :
      [...this.data];
  }

  asignData(value) {
    this.checkList.forEach((element, index) => {
      if (this.schema.hasDisabledCheckBoxItem) {
        this.checkList[index] = this.schema.hasDisabledCheckBoxItem(this.data[index]) ? false : value;
      } else {
        this.checkList[index] = value;
      }
    });
  }

  hasDisableCheckbox(row: any): boolean {
    if (this.schema.hasDisabledCheckBoxItem) {
      return this.schema.hasDisabledCheckBoxItem(row, this.dataCheckConfirm, this.schema);
    }
    return false;
  }

  openAccion(icon) {
    this.iconHeaderPanel.emit(icon);
  }

}
